export default __webpack_public_path__ + "static/recog-3-fdee09c992e2fcab99075025821dd54c.webp";